import { create } from 'zustand'

// Types
import type { ScrollStore } from '@/types/helpers/store/scroll'

const normalizePath = (path: string) => {
	if (!path || path === '/') return '/'

	return path.endsWith('/') ? path.slice(0, -1) : path
}

export const useScrollStore = create<ScrollStore>((set, get) => ({
	positions: {},
	save: path => {
		set(state => ({
			positions: { ...state.positions, [normalizePath(path)]: window.scrollY }
		}))
	},
	restore: path => {
		const saved = get().positions[normalizePath(path)]
		if (saved !== undefined) {
			window.scrollTo({ top: saved, left: 0, behavior: 'instant' })
		}

		return saved
	}
}))
